import { render, staticRenderFns } from "./TextareaRow.vue?vue&type=template&id=8b052900&"
import script from "./TextareaRow.vue?vue&type=script&lang=ts&"
export * from "./TextareaRow.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b052900')) {
      api.createRecord('8b052900', component.options)
    } else {
      api.reload('8b052900', component.options)
    }
    module.hot.accept("./TextareaRow.vue?vue&type=template&id=8b052900&", function () {
      api.rerender('8b052900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/TextareaRow.vue"
export default component.exports